import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { useCallback } from "react";
import { SchemaData } from "./types";
import { CreateGql, CREATE_QUERY } from "../queries/create";
import { ApiCourseRequest } from "data/queries/ApiCourse";
import { useNavigate } from "react-router-dom";

export default function useCreate() {
  const navigate = useNavigate();

  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    const { courseIds, ...data } = state?.data;

    const response = await ApiCourseRequest<CreateGql>({
      query: CREATE_QUERY,
      variables: {
        data: {
          ...data,
          content: courseIds.map((id, index) => ({
            courseId: id,
            sortValue: index + 1,
          })),
        },
      },
    });

    if (response?.data?.errors) {
      throw response.data.errors[0];
    }
    if (!response?.data?.data || !response?.data?.data?.createHighlightCourseShelf?.id) {
      throw new Error("Ops. Sem resposta!");
    }

    navigate(`/ecommerce/vitrines/${response.data.data.createHighlightCourseShelf.id}`);

    return response;
  }, []);

  return {
    handleSave,
  };
}
